<style scoped>
.modal {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9;
  background: #000;
  opacity: .3;
}

.modal-alert {
  position: fixed;
  width: 700px;
  background: #fff;
  z-index: 9;
  left: 50%;
  top: 50%;
  margin-left: -350px;
  transform: translateY(-50%);
  padding-bottom: 20px;
}

.title-content {
  height: 50px;
  border-bottom: 1px solid #D9D9D9;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  line-height: 50px;
  font-size: 18px;
  color: #212121;
}

.modal-alert .btns {
  width: 60px;
  height: 28px;
  background: #4FA1A4;
  border-radius: 2px;
  color: #fff;
  margin-top: 15px;
  float: right;
  margin-right: 20px;
  line-height: 28px;
  cursor: pointer;
  border: 1px solid #4FA1A4;
  font-size: 12px !important;

}

.modal-alert .close {
  cursor: pointer;
  color: #909399;
}

.modal-alert .close:hover {
  color: #409EFF;
}

.modal-alert .tips {
  background: #FFFBF2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 4px;
  margin: 15px;
  text-align: left;
  padding: 10px 20px;
  line-height: 25px;

}

.modal-alert .sub-title {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin-left: 20px;
  display: flex;
  align-items: center;
}

.modal-alert .sub-title span {
  background: #4FA1A4;
  width: 4px;
  height: 16px;
  display: inline-block;
  margin-right: 8px;
}

.person-search {
  display: flex;
  padding-left: 30px;
  padding-top: 10px;
  align-items: center;
  color: #666;
}

.person-search .item1 {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.person-search .item1 .label {
  margin-right: 10px;
}

.person-search .select-wrap {
  width: 250px;
}

/deep/ .table_header {
  background-color: #F0F0F0 !important;
  padding: 10px 0;
  color: #323233;
}

/deep/ .el-table td {
  padding: 10px 0px;
}
/deep/.el-input-number__decrease{
  height: 33px; 
  top:3px
}
/deep/ .el-input-number__increase{
  height: 33px; 
  top:3px
}

.table-wrap {
  margin: 20px
}
.btns.cancel {
  background: #FFFFFF;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
  color:#666;
}
.row{
  display: flex;
  align-items: center;
  padding-bottom: 8px;

}
.row .col-item{
  display: flex;
  align-items: center;
  padding-left: 20px;
}
.row .col-item .item-left{
  padding-right: 10px;
}
.row .col-item .item-right{
  width:250px;
  height: 40px;
 
}
</style>
<template>
  <div class="main" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="modal" @click="close"></div>
    <div class="modal-alert">
      <div class="title-content">
        <div class="title"  style="margin-bottom:0">批量下载</div>
        <i class="el-icon-close close" @click="close"></i>
      </div>
      <div class="tips">
        注意：请先选择你要下载的数据范围，系统会以压缩包的形式下载，最多可下载500张照片
      </div>
      <div class="row">
        <div class="col-item">
          <div class="item-left"><span style="color:red">*</span>选择公司</div>
          <el-select  class="item-right" v-model="downloadPage.tenantGuid" placeholder="请选择公司"  filterable @change="getStaffList(downloadPage.tenantGuid,true)">
              <el-option 
                v-for="item in tenantList"
                :key="item.sendTenantGuid"
                :label="item.sendTenantName"
                :value="item.sendTenantGuid"
              >
              </el-option>
          </el-select>
        </div>
        <div class="col-item">
         <div class="item-left">选择人员</div>
         <el-select class="item-right"  multiple collapse-tags v-model="downloadPage.staffGuid" placeholder="请选择人员"  filterable>
             <el-option 
              v-for="item in staffList"
              :key="item.guid"
              :label="item.staffName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="col-item">
          <div class="item-left"><span style="color:red">*</span>核算月份</div>
          <el-date-picker
            class="item-right"
            v-model="downloadPage.accountMonth"
            type="month"
            placeholder="请选择核算月份"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyyMM"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="btns" @click="submit">
        下载
      </div>
      <div class="btns cancel" @click="close">
        取消
      </div>
    </div>

  </div>
</template>
<script>
export default {
  props: {
  },
  data() {
    return {
      tenantList:[],
      staffList:[],
      downloadPage:{
        tenantGuid:'',
        accountMonth:'',
        staffs:[]
      },
      fullscreenLoading:false
    };
  },
  created() {
    this.getTenantList();
  },
  methods: {
    getTenantList() {
      let self = this;
      let query = {
        isService:true,
        tenantGuid:localStorage.guid
      };
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getStaffList(guid,flag) {
      let self = this;
      self.fullscreenLoading = true;
      this.api.get(
        `/${serverConfig.msPersonnelService}/staff/get-staff-by-tenantGuid?tenantGuid=` + guid
      ).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.staffList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    close() {
      this.$emit('close')
    },
    //提交
    submit(){
      let req = [];
      if (!this.downloadPage.tenantGuid) {
        this.$message.error('请先选择公司');
        return
      }
      if (!this.downloadPage.accountMonth) {
        this.$message.error('请选择核算月份');
        return
      }
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msCustomerService}/paymentCertificate/batch/download`,this.downloadPage).then(res=>{
        if (res.data.code) {
          this.fullscreenLoading = false;
          this.$message.error(res.data.msg);
        } else {
          this.downloadZip();
        }
      })
    },
    downloadZip(){
      this.api.postJsonD(`/${serverConfig.msCustomerService}/paymentCertificate/batch/download`,this.downloadPage)
        .then(res => {
          this.fullscreenLoading = false;
          if (res.data.code) {
            console.log(res.data)
            this.$message.error(res.data.msg);
          }else{
            let blob = new Blob([res.data], {  type: "application/zip"  });
            let fileName = '支付凭证-' + this.$moment(new Date()).format('YYYYMMDD');
            let objectUrl = URL.createObjectURL(blob);
            const link = document.createElement('a')
            link.download = fileName;
            link.href = objectUrl;
            link.click();
          }
        });
    }

  },
};
</script>